import { Box, Tab, Tabs, Typography } from "@mui/material";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import React from "react";
import ClickImpressionAction from "./ClickImpressionActionDate/ClickImpressionAction";
import ClickImpressionClick from "./ClickImpressionClickDate/ClickImpressionClick";

const ClickImpressionTabs = () => {
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  return (
    <>
      <Typography
        sx={{
          fontSize: typography.Size.Text.md.$value,
          my: 1,
          fontWeight: typography.Font_weight.Medium.$value,
        }}
      >
        Trends Details
      </Typography>

      <Tabs
        value={value}
        onChange={handleChange}
        centered
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: colors.GrayDarkMode[700].$value,
          },
          background: colors.GrayLightMode[100].$value,
          borderTop: "3px solid" + colors.GrayLightMode[100].$value,
          borderBottom: "3px solid" + colors.GrayLightMode[100].$value,
          borderRadius: spacing.Radius.md.$value,
          minHeight: spacing.Spacing["3xl"].$value,
          lineHeight: typography.Line_height.text.xs.$value,
          
        }}
        TabIndicatorProps={{
          sx: {
            height: spacing.Spacing.none.$value,
          },
        }}
      >
        {["Action Date", "Click Date"].map((label) => (
          <Tab
            key={label}
            label={label}
            disableRipple
            sx={{
              width: "49.1%",
              color: colors.GrayLightMode[500].$value,
              textTransform: "none",
              fontWeight: typography.Font_weight.Medium.$value,
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              padding: 0,
              minHeight: spacing.Spacing["3xl"].$value,
              "&.Mui-selected": {
                color: colors.GrayLightMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                backgroundColor: colors.Base.White.$value + "!important",
              },
              "&:hover": { backgroundColor: "transparent" },
            }}
          />
        ))}
      </Tabs>

      {/* 🔽 TAB CONTENTS */}
      <TabPanel value={value} index={0}>
        <ClickImpressionAction />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <ClickImpressionClick />
      </TabPanel>
    </>
  );
};

export default ClickImpressionTabs;
